import React from "react";
import { Select } from "antd";
import { useFetchClients } from "../../clients/hooks/useFetchClients";
import type { ClientData } from "../../clients/types";

interface PropsFormClient {
    currentClientId: number | undefined;
    handleChangeClient: (value: ClientData | undefined) => void;
}

const FormEditClient = ({ currentClientId, handleChangeClient }: PropsFormClient) => {
    const { data: clients, isLoading: isLoadingClients } = useFetchClients();

    return (
        <Select
            showSearch
            filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            style={{ width: '100%', marginBottom: 10 }}
            placeholder="Selecciona un cliente"
            loading={isLoadingClients}
            value={currentClientId}
            onChange={(value) => {
                const client = clients?.find((item) => item.id_client === value);
                handleChangeClient(client);
            }}
            options={clients ? clients.map((item) => {
                return {
                    label: item.client_name,
                    value: item.id_client
                }
            }) : []}
        />
    );
};

export default FormEditClient;
